import React from 'react';
import { useObservable } from 'react-use-observable';

import { Typography } from 'antd';

import leadsService from 'v2/services/leads/list';
import tableService from 'v2/services/table';

import Export from '../Export';

const Details = () => {
  const [totalItems] = useObservable(() => leadsService.getTotalItems(), []);
  const [loading] = useObservable(() => tableService.isLoading(), []);

  if (loading) {
    return null;
  }

  return (
    <div
      className='mb-4 flex w-full flex-row items-center justify-between rounded-md bg-(--uizz-antd-color-bg-container) p-4'
      id='leads-details'
    >
      <div>
        <Typography.Text strong id='leads-result-button-label' data-testid='leads-result-label'>
          {totalItems} leads
        </Typography.Text>
      </div>
      <div>
        <Export />
      </div>
    </div>
  );
};

export default Details;
